import {
  ManageTransmissionLineFormValue,
  ManageTransmissionLineOpticalFiberFormValue,
} from './manage-transmission-lines.interfaces';

export const TRANSMISSION_LINE_BUNDLE_OPTIONS = [
  { label: 'Single', value: 'Single' },
  { label: 'Double', value: 'Double' },
  { label: 'Quad', value: 'Quad' },
] as const;

export const TRANSMISSION_LINE_FIBER_TYPE_OPTIONS = [
  { label: 'OPGW', value: 'OPGW' },
  { label: 'ADSS', value: 'ADSS' },
  { label: 'UGFO', value: 'UGFO' },
] as const;

export const TRANSMISSION_LINE_FIBER_USE_OPTIONS = [
  { label: 'Communication', value: 'Communication' },
  { label: 'Protection', value: 'Protection' },
  { label: 'SCADA', value: 'SCADA' },
] as const;

export const TRANSMISSION_LINE_PARAMETER_OPTIONS = [
  { label: 'Line Flows', value: 'Line Flows' },
] as const;

export const TRANSMISSION_LINE_LOGSHEET_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
] as const;

export function createManageTransmissionLineFormValue(): ManageTransmissionLineFormValue {
  return {
    from_substation_id: null,
    to_substation_id: null,
    voltage_level_id: null,
    transmission_line_name: '',
    scada_code: '',
    parameter: '',
    logsheet: true,
    no_of_circuit: '',
    length_km: '',
    circuit_km: '',
    per_circuit_ampere: '',
    per_circuit_mva: '',
    total_capacity_mva: '',
    conductor_code_name: '',
    bundle: '',
    conductor_type: '',
    no_of_towers: '',
    starting_tower_no: '',
    ending_tower_no: '',
    is_crossborder: false,
  };
}

export function createManageTransmissionLineOpticalFiberFormValue(): ManageTransmissionLineOpticalFiberFormValue {
  return {
    no_of_core: '',
    length_of_optical_fiber_km: '',
    fiber_type: '',
    fiber_use: '',
    spark: '',
  };
}
